module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter One")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "chapterDateline"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("One month later, Denver, Colorado")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("H")])]), _vm._v("e couldn’t let her leave. Not without a fight. The spasm of panic shocked him, even as it pounded angry and insistent through his blood. For a moment—just one—Dr. Shane Bartlett had to fight the horrible urge to give in and beg, but he knew any display of emotion would be his doom.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("For the sake of his patients, he had to ignore the choking sense of dread rising inside him and continue.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Jaw tight, Shane dragged a hand through his hair. If he was to win her over, persuasion had to be doled out in degrees of charm and skill.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Putting aside his frustration, Shane forced his heartbeat to slow to the same rhythmic cadence as the tick-tick-tick coming from the clock on the mantel behind him.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("“Please, Miss Marley,” he said, curving a pleasant ")]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("smile along the edges of his mouth. “I only ask that you hold off making a final decision until you hear me out.”")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Her gaze remained direct and unwavering. But instead of responding right away, she clamped her lips shut and scrunched her forehead into a web of hard, vertical lines.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Shane felt his chest heave. Trying to gauge how best to present his argument, he dropped a glance over the woman in one quick swoop. Dressed in a drab gray dress and equally uninspired shoes, her bland brown hair looked as if it might have corroded onto her head. Her starched collar matched her rigid spine. In fact, she sat so straight and so far back in her chair, Shane was amazed the pattern from the upholstery hadn’t tattooed itself to her dress.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("When he raised his gaze to meet hers, the cold eyes and pursed lips reminded him of the women he’d encountered throughout his childhood on the streets of New York City.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("His instinct was to dismiss her at once. But he owed it to everyone involved to put his own feelings aside and conduct this interview with polite professionalism.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Taking another moment to control his emotions, Shane lowered his chin and scanned the references he held in his hand. He couldn’t deny Miss Marley had the nursing experience he needed in an assistant. Her background was without blemish, her training impeccable. But did she have the temperament required for the unique position he offered?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("There was one way to find out.")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“The Charity House orphans are—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Orphans?”")]), _vm._v(" Her eyes went narrow and frosty, while her lips curled with pitch-perfect disgust. “You use that term loosely, Dr. Bartlett.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("A muscle shifted in his jaw and Shane felt his smile slip.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Let the children come to me, and do not hinder them, for the Kingdom of God belongs to such as these…")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("At the reminder of Jesus’s words, Shane had to fight back a wave of resentment at the woman’s sanctimonious attitude.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Perhaps they are not orphans in the literal sense,” he acknowledged with a grim twist of his lips. “However, they are children who—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("She snorted. She actually "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("snorted")]), _vm._v(" at him. The sound was harsh enough to stop him in midsentence.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“These children.” He paused to emphasize his point, but then a dull drumming pounded in his ears and the pattern on the rug at his feet bled into a kaleidoscope of chaotic colors. Shane shook his head and began again. “These "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("children")]), _vm._v("…deserve decent medical care like everyone else.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("She pierced him with a sharp look and spoke as though she hadn’t heard his words. “This is a house for harlots’ mistakes.” She lifted her nose and looked pointedly around her. “Is it not, Dr. Bartlett?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Before responding, Shane followed her gaze as it moved beyond the Persian rugs, past the expensive furniture, and straight to the crystal vases filled with fresh-cut flowers. The attention to detail was impossible to miss. Charity House was like no other orphanage in the territory, incomparable in its elegance and style.")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("And yet, Shane wondered if he’d made a mistake in choosing the mansion’s front parlor as the place to conduct his interviews today.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He’d hoped that by showing the candidates the interior of the orphanage they would realize Charity House and its occupants had class and substance. Apparently, instead of unleashing this nursing candidate’s compassion, he’d opened her judgment.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Whispered reminders of his own childhood crept forward in his mind. Shane clenched his jaw, refusing to allow this woman to see his growing anger until he had the poisonous emotion under control.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He forced his shoulders to relax.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Whatever you might think of these children, remember they did not choose their parents,” he said, surprised to hear his calm tone when so many ugly emotions churned just under the surface. “As I said before, they deserve equal and fair medical treatment.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He pierced her with a hard look, daring her to argue.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("She blinked. Blinked again. Swallowed. Then slowly nodded. “I will concede your point, doctor. However, the children’s situation notwithstanding, I am entitled to know about your other patients. What of the mothers still alive, the ones working in the brothels on Market Street?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Shane held her stare. “I treat them, as well. And anyone else in need. I turn none away.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("A sound of outrage slipped from her lips. “Innocent children are one thing, but their mothers are quite another. You did not say in your advertisement that you care for…for…sinners.”")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Her words were like a solid punch to his gut. How often had he heard similar accusations thrown at his own mother, all because she had chosen to be a wealthy man’s mistress?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Memories lurking below the surface bubbled forth, taunting him. Shane’s breath turned cold in his lungs under the assault.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Yes, his mother had been a sinner, but she had paid dearly for her mistakes. She’d died in shame, and there had been nothing Shane could do to stop the tragedy.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He’d been too young, too inexperienced, too—")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Another unladylike sniff yanked him back to the present.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“You have nothing else to say to me, doctor?” she asked. “What is your defense for misleading me into thinking this was an ordinary nursing position?” The chill of her tone sat heavy in the room between them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Shane fought to keep his resentment and anger from taking control of his reason. What had he been thinking, to allow this interview to continue so long?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He could never subject the Charity House children, their mothers, or any of his patients for that matter, to this woman and her…judgment.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He owed it to the memory of his own mother to find a compassionate nurse to assist him in his practice. Was guilt driving him to care for the disenfranchised? Guilt over failing the one woman who had sacrificed her life for him. Or was it true conviction that pushed him to care for the unwanted?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("He wasn’t sure anymore. Nor was he convinced his ")]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("motives mattered. His patients, and their care, had to come first.")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("With his mind made up, Shane rose from his chair and waited until the woman did the same. “Thank you for your time, Miss Marley. I am no longer in need of your services.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He did not offer her his hand.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“You are dismissing "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("me?")]), _vm._v("” The woman had the nerve to look mutinous, as though she was being unfairly sent away. “But you need my assistance. You said so yourself at the beginning of this interview.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("With each breath he took, his patience wore thinner. “I think it is best we part ways at this juncture.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Gasping, she threw her shoulders back and lifted her chin high in the air. “I’m your last candidate,” she said. “You have no one else.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“I am confident God will provide.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“You will regret this,” she warned.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Shane met her gaze with an unrelenting glare of his own. “I will not.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He’d never spoken truer words. For although he knew things would get worse before they got better, he also knew he just needed a little more faith, a little more patience. All would work for the best.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("With a loud huff, Miss Eugenia Marley skimmed her ice-edged gaze across him, turned on her heel and marched out of the room. Each angry step she took sounded like a hammer hitting unforgiving iron.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("Shane stood stock-still, staring straight ahead. He ")]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("barely flinched when she slammed the door behind her with a loud bang.")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("For several moments he remained unmoving, looking out the window facing the backyard of Charity House. The wind beat at the glass with an angry fist, sending an unrelenting howl past a crack between the pane and wood casing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("A perfect expression of his own frustration.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("There was no one left to interview. Shane could only hope that—")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("No.")]), _vm._v(" He would not waste precious energy on hope. Nor would he worry.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("He would trust.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Rolling his shoulders, Shane shoved a hand through his hair and shut his eyes. He let the tension drain from him for a single moment. And then another. And another still. Waiting until his mind cleared enough to focus on prayer.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("At last, he whispered, “Lord, I cannot do this alone. Where man fails, I know You excel. I pray You bless my patients with a compassionate woman to assist us.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Opening his eyes, Shane looked around the parlor room of Charity House. At first glance nobody would think this large and fancy mansion housed over forty children with nowhere else to go. Marc and Laney Dupree had created a home filled with compassion and caring, a refuge for the abandoned and unwanted boys and girls no other orphanage would touch.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("The Duprees’ generosity of spirit humbled Shane and inspired him to expand his own medical practice in ")]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("the same vein, a practice that was becoming unmanageable for one man.")])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Trust.")]), _vm._v(" He had to trust that God had a plan. The Lord would bring relief in His perfect time.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("A deep clearing of a throat jerked Shane out of his reverie. Pivoting at the sound, he locked his gaze with Marc Dupree’s concerned expression. Dressed in a brocade vest and matching tie, with his dark hair immaculately combed and face clean shaven, Marc looked more like a banker than the fierce proprietor of an orphanage. But just like Charity House, Shane knew the other man had hidden depths, and was an example of complete integrity.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Any success?” Marc asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Shane shook his head at his friend, and jammed his hands in his pockets. “It appears I’ve wasted another day with fruitless interviews.” He lifted a shoulder in a helpless gesture. “Perhaps—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("A high-pitched scream cut off his words, followed by a round of incomprehensible shouting. Shane’s ears pricked when he heard one voice rise above the others. “Somebody find Dr. Shane. Hurry.”")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Bella pivoted in several directions, searching desperately for the source of the panicked cries tumbling over one another.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Forcing herself to remain calm, she took a deep breath, stood immobile and listened intently. The shouts were coming from behind her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("She spun around and gasped at the sight before her. ")]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("Chaos had erupted in the massive yard that backed up to her brother’s church.")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Heart in her throat, Bella lurched forward. Stopped. Frowned.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Hadn’t she learned from her recent experience with William that it was better to assess a situation before rushing headlong into the unknown?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Dreadful memories of her last meeting with the viscount slammed through her mind, washing away her concentration. She shook her head violently and gritted her teeth so hard her jaw hurt. Bella knew she should find the source of the disaster unraveling in front of her. Instead, exhaustion, shame and anger at William’s betrayal threatened to steal her focus.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("No. No, no, no. William would not invade her thoughts today.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Breathe, Bella, breathe.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("One heartbeat passed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("And another.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("By the third, Bella had taken in the stylish mansion at the opposite end of the yard. The fairy-tale backdrop was at odds with the trouble riding along the stiff mountain breeze. She counted over fifteen children of various sizes colliding into one another. Like waves crashing onto a beach, they plunged toward a common point—a child lying flat on his back.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Bella curled her fingers into fists. Where was the adult in charge?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("Tossing her reticule to the ground, she sprinted toward the clump of frightened children. She’d barely ")]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("taken two steps when a young girl of about ten years of age skidded to a stop at her side. The child had halted so abruptly that her shiny black pigtails swung forward and then landed with a soft thump on her narrow shoulders. Eyes wild and unfocused, her little cupid mouth worked quickly, but no sound came out.")])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Bella stooped to the girl’s height and touched her shoulder. “Deep breaths, sweetie. Take one at a time.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Nodding, the girl gulped in large chunks of air.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“That’s it,” Bella said. “Now tell me what’s happened.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“It’s…it’s…” She broke off and looked frantically around her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Bella rolled her shoulders and prayed for patience. “It’s…” she prompted in what she hoped was a soothing tone.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“My. Brother. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ethan.")]), _vm._v("” She pointed to the cluster of children knotted around a small boy lying on the ground. “He hurt his leg. You gotta get Dr. Shane for me.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Where?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("The girl cocked her head toward the mansion behind her. “Inside.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Bella placed her palm on the child’s cheek. “Don’t worry. I’ll get him.” Rising, she gave the girl’s shoulder an encouraging squeeze. “You see to your brother. And whatever you do, make sure he doesn’t move until the doctor gets there.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("As though she hadn’t heard a word Bella said, the child stabbed her gaze back to her brother, over to the large house behind her, then back to her brother again.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Did you hear me?” Bella asked.")])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("The girl nodded. Gulped. Gulped again. Then finally—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("finally")]), _vm._v("—she lifted her chin and lurched toward the injured boy.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Bella whirled in the direction of the house. At the same moment, two large men exited the backdoor in a run.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Bella faltered in her steps, froze. In her stunned state, she only had time for impressions. Both men were tall. Dark-haired. Broad-shouldered. One was dressed in expensive clothing that would make her flamboyant brother Tyler fall to his knees and weep with envy. The other wore a nondescript white shirt and black pants and carried a small black bag.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Dr. Shane.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("The calm in his manner gave Bella such a sense of relief she pressed a hand to her throat and sighed. This man would make everything better.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("The young girl changed directions and dashed to the bottom of the porch steps. “Ethan’s hurt, Dr. Shane.” She grasped his hand and tugged. “You gotta come quick.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("The sharp planes of his face tensed and his mouth pressed into a tight line. Yet, he carefully patted the girl on her back. “Don’t worry, Molly. I’ll take care of him.” His smooth baritone was pitched to the perfect level to instill calm. “You concentrate on finding your mother and father and then bring them here.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Right.” Teetering from one foot to the other, arms flailing, the child found her center at last and set off at a terrifying pace.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("Focused on his task once more, the doctor lengthened his strides. With each step, his gaze shifted over the ")]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_vm._v("scene, taking note of every detail. He measured, assessed. Picked up the pace.")])]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("The other man followed hard on his heels.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Negotiating the final few feet, the doctor gently set two of the smaller children to one side and then dropped to his knees. “Marc,” he threw over his shoulder. “I need room.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("The fancy-dressed man went to work at once. With an authoritative tone and in-charge manner, he organized the children into two work groups. In perfect rhythm they shifted away from the injured boy, picked up toys, balls, shoes and began setting them into neat piles.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("They were so purposeful in their task, so obedient, even as the nightmare churned around them, that Bella found herself gaping.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("What sort of children were these? And then she remembered her brother’s many letters telling her about the unique orphanage that shared the church’s backyard. Charity Home. No. Charity House. Yes, that was the name.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Before she could take another look at the mansion-turned-orphanage, the doctor darted his gaze along the perimeter of the yard as though he was searching for something. Or someone. A helper, perhaps? Before Bella could offer her assistance, his eyes locked on to hers.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Snared in his powerful stare, her lungs constricted. Although she was too far away to make out the individual features of his face, the impact of all that intensity thrown her way had her stepping sharply back.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“You, there,” he said, his features twisting into a frown of concentration. “I need your assistance.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_vm._v("Jolted into action, Bella yanked off one glove and ")]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_vm._v("then another. “Yes, of course.” By the time she’d crossed the yard, she’d tossed her hat to the ground, as well.")])]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("The children continued to chatter softly as they made room for the doctor to work. Their voices rose slightly as they began trooping one by one inside the large house but it was all background noise now. Never taking her attention off the boy, Bella knelt beside him and looked into his small, pale face.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Glassy eyes stared back at her. She swallowed down a gasp of surprise. He was so young, no more than four or five, with black curly hair and big brown eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Lord, please ease this child’s pain. Use me as your instrument to erase his suffering.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Unsure what to do next, she waited for specific instructions from the doctor. When none came, a shiver of foreboding iced across her skin.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Cautiously, she lifted her gaze. And found herself staring into ocean-blue eyes the exact color as William’s.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Unwelcome images swirled through her mind like leaves on a deserted street. Incapable of grasping any one thought before it was replaced by another, her mind drained into a black void of nothingness.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Air clogged in her lungs.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Focus, Bella. Focus, focus, focus.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("The doctor must have sensed her internal struggle because his eyes narrowed to inscrutable slits.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Bella quickly lowered her gaze back to the hurt boy. Little Ethan’s eyes were ringed with pain. Tears wavered on the edges of his lashes, but he gritted his teeth and released a shaky sigh.")])]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("“Oh, you brave little boy.” Bella touched his cheek softly then brushed the sweaty hair off his forehead with her fingertips. “You’re going to be fine. Just fine.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("As though her words gave him permission to give into the pain, the tears spilled from his eyes. “It…it hurts,” he gasped, his young voice shaking with anguish. “Real bad.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Bella stroked her hand along his hairline. “I know it does, baby. But the doctor is going to make it better.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Shutting out all thoughts but this small, helpless child, she boldly returned her gaze to the doctor’s face. “Isn’t that right, Dr. Shane?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("The sun chose that moment to break through a slit in the fast-moving clouds. Big. Hot. Illuminating.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("The doctor stared at her for a long, tense moment. This time, Bella couldn’t look away. The bold, aristocratic angles of his cheekbones, the finely shaped nose and strong jaw covered with day-old stubble created a handsome portrait any leading man would covet.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Bella blinked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Slowly—very, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("very")]), _vm._v(" slowly—Dr. Shane dropped his gaze to the child. “I’ll do my best, Ethan.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("The boy let out another shaky sigh. “I know.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Dr. Shane cut his gaze back to Bella. “Let’s get to work, shall we?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("His words were more statement than question, but there was an edge of doubt in his eyes. He was asking her to assist him, daring her perhaps, yet convinced she’d somehow let him down.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Would she? She had no training, no experience. Yet an injured boy needed her.")])]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Lord, give me the courage to do what is needed.")])]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("Fortunately, the very moment she ended her prayer, Bella’s worries fell away. All that remained was a driving sense of purpose.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("She swallowed back the last shreds of uncertainty and boldly held Dr. Shane’s gaze. “Tell me what to do.”")])])]), _c('a', {
    attrs: {
      "id": "page34"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page34"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d24b6cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/lovingbella_ch01.vue
// module id = 81
// module chunks = 0